export default {
    "lyrics": [
        {
            "characters": ["greg"],
            "time": "00:10",
            "lyric": "Let's go for a walk"
        },
        {
            "characters": ["greg"],
            "time": "00:12",
            "lyric": "I want to talk to you about a blessing in disguise"
        },
        {
            "characters": ["greg"],
            "time": "00:24",
            "lyric": "When I was 8, my mom told me"
        },
        {
            "characters": ["greg"],
            "time": "00:26",
            "lyric": "To always see the cup half full"
        },
        {
            "characters": ["greg"],
            "time": "00:28",
            "lyric": "How beautiful are the feet of those who"
        },
        {
            "characters": ["greg"],
            "time": "00:29",
            "lyric": "Bring good news"
        },
        {
            "characters": ["greg"],
            "time": "00:30",
            "lyric": "Of good things. Wanted to talk to you"
        },
        {
            "characters": ["greg"],
            "time": "00:32",
            "lyric": "Now listen to me"
        },
        {
            "characters": ["greg"],
            "time": "00:34",
            "lyric": "I know we received Bis of dollars in capital"
        },
        {
            "characters": ["greg"],
            "time": "00:36",
            "lyric": "Mostly venture capital"
        },
        {
            "characters": ["greg"],
            "time": "00:37",
            "lyric": "And you know that I know that I pride myself in being unflappable"
        },
        {
            "characters": ["greg"],
            "time": "00:39",
            "lyric": "And you of all men"
        },
        {
            "characters": ["greg"],
            "time": "00:40",
            "lyric": "Placable, intelligible, intelligent man"
        },
        {
            "characters": ["greg"],
            "time": "00:42",
            "lyric": "Dress well. Well is a hole in the ground, but I digress. Well..."
        },
        {
            "characters": ["greg"],
            "time": "00:44",
            "lyric": "Something crazy happened today"
        },
        {
            "characters": ["greg"],
            "time": "00:45",
            "lyric": "We were taking a look at our balance sheet"
        },
        {
            "characters": ["greg"],
            "time": "00:46",
            "lyric": 'We were like "oh shit. Oh well, we might need some monnaie"'
        },
        {
            "characters": ["greg"],
            "time": "00:48",
            "lyric": "That's probably what it means."
        },
        {
            "characters": ["greg"],
            "time": "00:49",
            "lyric": "It's not that we realy need need NEED."
        },
        {
            "characters": ["greg"],
            "time": "00:50",
            "lyric": "Would you like some of this?"
        },
        {
            "characters": ["vc"],
            "time": "00:51",
            "lyric": "No"
        },
        {
            "characters": ["greg"],
            "time": "00:52",
            "lyric": "Noir from an island in Italy"
        },
        {
            "characters": ["vc"],
            "time": "00:53",
            "lyric": "-"
        },
        {
            "characters": ["greg"],
            "time": "00:54",
            "lyric": "(stalling) This is a fine wine from a collection of mine"
        },
        {
            "characters": ["greg"],
            "time": "00:55",
            "lyric": "I need to fill in this rhyme"
        },
        {
            "characters": ["greg"],
            "time": "00:56",
            "lyric": "I've got some Malbec in the back"
        },
        {
            "characters": ["vc"],
            "time": "00:58",
            "lyric": "No, thanks"
        },
        {
            "characters": ["greg"],
            "time": "00:59",
            "lyric": "Ok. What I wanted to convey"
        },
        {
            "characters": ["greg"],
            "time": "01:00",
            "lyric": "What I wanted to relay"
        },
        {
            "characters": ["greg"],
            "time": "01:01",
            "lyric": "What I really really really really wanted to say:"
        },
        {
            "characters": ["vc"],
            "time": "01:02",
            "lyric": "-"
        },
        {
            "characters": ["greg"],
            "time": "01:03",
            "lyric": "Stay calm and don't panic"
        },
        {
            "characters": ["greg"],
            "time": "01:05",
            "lyric": "And please don't be alarmed guys"
        },
        {
            "characters": ["vc"],
            "time": "01:06",
            "lyric": "Don't be alarmed guys?"
        },
        {
            "characters": ["greg"],
            "time": "01:09",
            "lyric": "Stay calm and don't panic"
        },
        {
            "characters": ["greg"],
            "time": "01:11",
            "lyric": "This is a blessing in disguise (2x)"
        },
        {
            "characters": ["vc"],
            "time": "01:13",
            "lyric": "-"
        },
        {
            "characters": ["greg"],
            "time": "01:13",
            "lyric": "I know you've always trusted us with your Benjamins"
        },
        {
            "characters": ["greg"],
            "time": "01:15",
            "lyric": "Back during the vid, we invested money in some opportunities"
        },
        {
            "characters": ["greg"],
            "time": "01:17",
            "lyric": "Listen"
        },
        {
            "characters": ["greg"],
            "time": "01:18",
            "lyric": "Lately little did we know a little lingering leaky unintelligibility'd"
        },
        {
            "characters": ["greg"],
            "time": "01:21",
            "lyric": "Lead to losses and rates to increase"
        },
        {
            "characters": ["vc"],
            "time": "01:24",
            "lyric": "What are you saying?"
        },
        {
            "characters": ["vc"],
            "time": "01:25",
            "lyric": "Just rip off the band-aid"
        },
        {
            "characters": ["vc"],
            "time": "01:26",
            "lyric": "We trust you, and we are on your side"
        },
        {
            "characters": ["greg"],
            "time": "01:29",
            "lyric": "You are far too kind. You and me this is right"
        },
        {
            "characters": ["greg"],
            "time": "01:30",
            "lyric": "Look in my eyes. Everything is gonna be alright"
        },
        {
            "characters": ["vc"],
            "time": "01:31",
            "lyric": "-"
        },
        {
            "characters": ["greg"],
            "time": "01:32",
            "lyric": "Stay calm and don't panic"
        },
        {
            "characters": ["greg"],
            "time": "01:34",
            "lyric": "And please don't be alarmed guys"
        },
        {
            "characters": ["greg"],
            "time": "01:36",
            "lyric": "Don't be alarmed guys"
        },
        {
            "characters": ["greg"],
            "time": "01:37",
            "lyric": "Stay calm and don't panic"
        },
        {
            "characters": ["greg"],
            "time": "01:40",
            "lyric": "This is a blessing in disguise (2x)"
        },
        {
            "characters": ["greg"],
            "time": "01:42",
            "lyric": "Stay calm and don't panic"
        },
        {
            "characters": ["greg"],
            "time": "01:44",
            "lyric": "And please don't be alarmed guys"
        },
        {
            "characters": ["greg"],
            "time": "01:45",
            "lyric": "Don't be alarmed guys"
        },
        {
            "characters": ["vc"],
            "time": "01:47",
            "lyric": "Everything is gonna be alright?"
        },
        {
            "characters": ["greg"],
            "time": "01:48",
            "lyric": "Stay calm and don't panic"
        },
        {
            "characters": ["greg", "vc"],
            "time": "01:50",
            "lyric": "This is a blessing in disguise (2x)"
        },
        {
            "characters": ["greg"],
            "time": "01:53",
            "lyric": "Stay calm and don't panic"
        },
        {
            "characters": ["greg"],
            "time": "01:53",
            "lyric": "And please don't be alarmed guys"
        },
        {
            "characters": ["vc"],
            "time": "01:54",
            "lyric": "Don't be alarmed guys?"
        },
        {
            "characters": ["greg"],
            "time": "01:57",
            "lyric": "Stay calm and don't panic"
        },
        {
            "characters": ["greg"],
            "time": "01:58",
            "lyric": "This is a blessing in disguise (2x)"
        },
        {
            "characters": ["vc"],
            "time": "02:00",
            "lyric": "-"
        },
        {
            "characters": ["greg"],
            "time": "02:03",
            "lyric": "So, yeah we might need to raise some fresh cash"
        },
        {
            "characters": ["greg"],
            "time": "02:04",
            "lyric": "To balance our balance sheet"
        },
        {
            "characters": ["greg"],
            "time": "02:05",
            "lyric": "Also maybe sell some shares"
        },
        {
            "characters": ["greg"],
            "time": "02:06",
            "lyric": "Maybe a couple billion dollars"
        },
        {
            "characters": ["greg"],
            "time": "02:07",
            "lyric": "For outside investors or for ya"
        },
        {
            "characters": ["greg"],
            "time": "02:10",
            "lyric": "You know... We are moving money around. Holla!"
        },
        {
            "characters": ["greg"],
            "time": "02:11",
            "lyric": "Hum... What else?"
        },
        {
            "characters": ["greg"],
            "time": "02:12",
            "lyric": "That helps. It's just for a little bit"
        },
        {
            "characters": ["greg"],
            "time": "02:13",
            "lyric": "Nothing out of the ordinary is happening"
        },
        {
            "characters": ["greg"],
            "time": "02:14",
            "lyric": "People can cut the checks"
        },
        {
            "characters": ["greg"],
            "time": "02:15",
            "lyric": "Next thing you know. Just like dipping and dapping"
        },
        {
            "characters": ["greg"],
            "time": "02:16",
            "lyric": "You won't have to stop going to the beaches or sipping"
        },
        {
            "characters": ["greg"],
            "time": "02:18",
            "lyric": "Mimosas. Shake my hands, my body's gon' sound chin chin 🤑"
        },
        {
            "characters": ["greg"],
            "time": "02:21",
            "lyric": "But anyways. This shake goes both ways"
        },
        {
            "characters": ["greg"],
            "time": "02:23",
            "lyric": "Remember what I relayed"
        },
        {
            "characters": ["greg"],
            "time": "02:24",
            "lyric": "What I conveyed"
        },
        {
            "characters": ["greg"],
            "time": "02:25",
            "lyric": "What I really really really really wanted to say"
        },
        {
            "characters": ["greg"],
            "time": "02:27",
            "lyric": "Stay calm and don't panic"
        },
        {
            "characters": ["greg"],
            "time": "02:29",
            "lyric": "And please don't be alarmed guys"
        },
        {
            "characters": ["greg"],
            "time": "02:30",
            "lyric": "Don't be alarmed guys"
        },
        {
            "characters": ["greg"],
            "time": "02:32",
            "lyric": "Stay calm and don't panic"
        },
        {
            "characters": ["greg"],
            "time": "02:33",
            "lyric": "This is a blessing in disguise (2x)"
        },
        {
            "characters": ["greg"],
            "time": "02:33",
            "lyric": "This is a blessing in disguise (2x)"
        },
        {
            "characters": ["greg"],
            "time": "02:37",
            "lyric": "Stay calm. Don't planic."
        },
        {
            "characters": ["vc"],
            "time": "02:37.5",
            "lyric": "What are you saying? Just rip of the band-aid."
        },
        {
            "characters": ["greg"],
            "time": "02:38",
            "lyric": "And please don't be alarmed guys"
        },
        {
            "characters": ["vc"],
            "time": "02:38",
            "lyric": "We trust you, and we are on your side"
        },
        {
            "characters": ["greg"],
            "time": "02:39",
            "lyric": "Don't be alarmed guys"
        },
        {
            "characters": ["greg"],
            "time": "02:40",
            "lyric": "Stay calm. Don't planic"
        },
        {
            "characters": ["vc"],
            "time": "02:41",
            "lyric": "You are far too kind. You and me, this is right"
        },
        {
            "characters": ["vc"],
            "time": "02:42",
            "lyric": "-"
        },
        {
            "characters": ["greg"],
            "time": "02:43",
            "lyric": "This is a blessing in disguise (2x)"
        },
        {
            "characters": ["vc"],
            "time": "02:41",
            "lyric": "Look in my eyes, everything is gonna be alright"
        },
        {
            "characters": ["greg"],
            "time": "02:46",
            "lyric": "Stay calm and don't panic"
        },
        {
            "characters": ["vc"],
            "time": "02:48",
            "lyric": "Look in my eyes, everything is gonna be alright"
        },
        {
            "characters": ["greg"],
            "time": "02:49",
            "lyric": "And please don't be alarmed guys"
        },
        {
            "characters": ["greg"],
            "time": "02:51",
            "lyric": "Stay calm and don't panic"
        },
        {
            "characters": ["greg"],
            "time": "02:55",
            "lyric": "This is a blessing in disguise (2x)"
        },
        {
            "characters": ["greg"],
            "time": "02:57",
            "lyric": "Stay calm and don't panic"
        },
        {
            "characters": ["greg"],
            "time": "02:58",
            "lyric": "This is a blessing in disguise"
        },
        {
            "characters": ["vc"],
            "time": "02:59",
            "lyric": "You can count on us, alright? We won't tell anyone."
        },
    ]
}
